const REST_API_SHS_WEB =
  globals.NODE_ENV === 'production'
    ? {
        URL: {
          v1Testimonials: 'https://pxxeanv7g2.execute-api.us-east-1.amazonaws.com/ccapp-vzw-test/v3/testimonials',
          submitClaim: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/v1/claimstool',
          validateStore: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/v1/validatestore',
          retrieveStoreStats: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/storestats',
          retrieveUserStats: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/userstats',
          dashboardStats: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/dashboardstats',
          listAllAppointments: '',
          editAppointment: '',
          cancelAppointment: '',
          createAppointment:
            'https://pxxeanv7g2.execute-api.us-east-1.amazonaws.com/ccapp-vzw-test/v3/insertCustomerData',
          usedAppointmentTimeSlots:
            'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/timestamp',
          csdb: 'https://pxxeanv7g2.execute-api.us-east-1.amazonaws.com/ccapp-vzw-test/v3/csdbproxy',
          vhtAddAppointment: 'https://pxxeanv7g2.execute-api.us-east-1.amazonaws.com/ccapp-vzw-test/v3/updatevht',
          vhtGetNextAvailableAppointmentTime:
            'https://pxxeanv7g2.execute-api.us-east-1.amazonaws.com/ccapp-vzw-test/v3/fetchtimeslotsfromvht',
          experiencesVhtGetNextAvailableAppointmentTime:
            'https://pxxeanv7g2.execute-api.us-east-1.amazonaws.com/ccapp-vzw-test/v3/fetchtimeslotsfromvht',
          sendV1IdAndVhtId:
            'https://pxxeanv7g2.execute-api.us-east-1.amazonaws.com/ccapp-vzw-test/v3/updateCustomerData',
          feedback: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/feedback',
          reporting: 'https://pxxeanv7g2.execute-api.us-east-1.amazonaws.com/ccapp-vzw-test/v3/sendreportingevents',
          getAppointment: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/getcustomerbyid',
          getAtlasId: 'https://pxxeanv7g2.execute-api.us-east-1.amazonaws.com/ccapp-vzw-test/v3/getUniversalId',
          retrieveQuotesAndTips: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/quotes',
          getCustomerByMdn: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/getcustomerbymdn',
          survey: 'https://pxxeanv7g2.execute-api.us-east-1.amazonaws.com/ccapp-vzw-test/v3/suggesttopic',
          joinResearch: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/joinresearch',
          decrypt: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/v1/decrypt',
          fonoApiUrl: 'https://fonoapi.freshpixl.com/v1/getdevice',
          leaderBoard: 'https://53020nhmrc.execute-api.us-east-1.amazonaws.com/v1/leaderboard',
          campaignDetails:
            'https://f65v6lll19.execute-api.us-east-1.amazonaws.com/v1/vzw/campaign/v1/notificationdetails?id=',
          expertSessionsAppointment:
            'https://pxxeanv7g2.execute-api.us-east-1.amazonaws.com/ccapp-vzw-test/v3/getappointmentinfo',
          expertSessionsFeedback:
            'https://pxxeanv7g2.execute-api.us-east-1.amazonaws.com/ccapp-vzw-test/v3/insertSurveyResponse',
          expertSessionsJoinResearch:
            'https://pxxeanv7g2.execute-api.us-east-1.amazonaws.com/ccapp-vzw-test/v3/insertFeedbackEmails',
          unsubscribe: 'https://f65v6lll19.execute-api.us-east-1.amazonaws.com/v1/vzw/campaign/v1/unsubscribe',
        },
        KEY: {
          recaptcha: '6LdkDYMUAAAAAPUXfHG-dtLCMsQhxgGTn-RoJk38',
          mixpanelApiKey: 'Yc7nr43fsJaJbGAm5gpMtbxvHVh8RxY7DrEqqUbW',
          mixpanelSource: 'shs-experiences',
          carrier: 'vzw',
          scope: 'SHS_EXPERT_SESSIONS',
        },
        VHTSEGMENT: {
          mysheduleSegment: {
            key: 'ATT.en-us.Soluto_Mega1.',
            value: 'ATT_MPC',
          },
        },
      }
    : {
        URL: {
          v1Testimonials: 'https://2ibzptpa5c.execute-api.us-east-1.amazonaws.com/ccapp-vzw-test/v3/testimonials',
          submitClaim: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/v1/claimstool',
          validateStore: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/v1/validatestore',
          retrieveStoreStats: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/storestats',
          retrieveUserStats: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/userstats',
          dashboardStats: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/dashboardstats',
          listAllAppointments: '',
          editAppointment: '',
          cancelAppointment: '',
          createAppointment:
            'https://2ibzptpa5c.execute-api.us-east-1.amazonaws.com/ccapp-vzw-test/v3/insertCustomerData',
          usedAppointmentTimeSlots:
            'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/timestamp',
          csdb: 'https://2ibzptpa5c.execute-api.us-east-1.amazonaws.com/ccapp-vzw-test/v3/csdbproxy',
          vhtAddAppointment: 'https://2ibzptpa5c.execute-api.us-east-1.amazonaws.com/ccapp-vzw-test/v3/updatevht',
          vhtGetNextAvailableAppointmentTime:
            'https://2ibzptpa5c.execute-api.us-east-1.amazonaws.com/ccapp-vzw-test/v3/fetchtimeslotsfromvht',
          experiencesVhtGetNextAvailableAppointmentTime:
            'https://2ibzptpa5c.execute-api.us-east-1.amazonaws.com/ccapp-vzw-test/v3/fetchtimeslotsfromvht',
          sendV1IdAndVhtId:
            'https://2ibzptpa5c.execute-api.us-east-1.amazonaws.com/ccapp-vzw-test/v3/updateCustomerData',
          feedback: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/feedback',
          reporting: 'https://2ibzptpa5c.execute-api.us-east-1.amazonaws.com/ccapp-vzw-test/v3/sendreportingevents',
          getAppointment: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/getcustomerbyid',
          getAtlasId: 'https://2ibzptpa5c.execute-api.us-east-1.amazonaws.com/ccapp-vzw-test/v3/getUniversalId',
          retrieveQuotesAndTips: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/quotes',
          getCustomerByMdn: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/getcustomerbymdn',
          survey: 'https://2ibzptpa5c.execute-api.us-east-1.amazonaws.com/ccapp-vzw-test/v3/suggesttopic',
          joinResearch: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/joinresearch',
          decrypt: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/v1/decrypt',
          fonoApiUrl: 'https://fonoapi.freshpixl.com/v1/getdevice',
          leaderBoard: 'https://53020nhmrc.execute-api.us-east-1.amazonaws.com/v1/leaderboard',
          campaignDetails:
            'https://u8hgm6aw99.execute-api.us-east-1.amazonaws.com/v1/vzw/campaign/v1/notificationdetails?id=',
          expertSessionsAppointment:
            'https://2ibzptpa5c.execute-api.us-east-1.amazonaws.com/ccapp-vzw-test/v3/getappointmentinfo',
          expertSessionsFeedback:
            'https://2ibzptpa5c.execute-api.us-east-1.amazonaws.com/ccapp-vzw-test/v3/insertSurveyResponse',
          expertSessionsJoinResearch:
            'https://2ibzptpa5c.execute-api.us-east-1.amazonaws.com/ccapp-vzw-test/v3/insertFeedbackEmails',
          unsubscribe: ' https://u8hgm6aw99.execute-api.us-east-1.amazonaws.com/v1/vzw/campaign/v1/unsubscribe',
        },
        KEY: {
          recaptcha: '6LdkDYMUAAAAAPUXfHG-dtLCMsQhxgGTn-RoJk38',
          mixpanelApiKey: 'Yc7nr43fsJaJbGAm5gpMtbxvHVh8RxY7DrEqqUbW',
          mixpanelSource: 'shs-experiences',
          carrier: 'vzw',
          scope: 'SHS_EXPERT_SESSIONSQA',
        },
        VHTSEGMENT: {
          mysheduleSegment: {
            key: 'ATT.en-us.Soluto_Mega1.',
            value: 'ATT_MPC',
          },
        },
      };

export default REST_API_SHS_WEB;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/config/restApi.SHS-WEB.js